"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _tinymce = _interopRequireDefault(require("tinymce"));

var _constants = require("../constants");

var noop = function noop() {}; // eslint-disable-line no-empty-function


var Modes = {
  READONLY: 'readonly',
  DESIGN: 'design'
};
var nextId = 1;

var getId = function getId() {
  var id = "react-tinymce-" + nextId;
  nextId++;
  return id;
};

var TinyMCE =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TinyMCE, _Component);

  function TinyMCE() {
    (0, _classCallCheck2.default)(this, TinyMCE);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TinyMCE).apply(this, arguments));
  }

  (0, _createClass2.default)(TinyMCE, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.id = getId();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var config = this.props.config;
      this.init(config);
    }
    /*
    * While content changed can be used to identify when we ought setContent
    * to control this component; we should never setContent while the editor is
    * in focus to avoid cursor location jumping while the editor is in use
    */

  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.editor.hasFocus() && !nextProps.readOnly) {
        return false;
      }

      return this.shouldReinitialize(this.props, nextProps) || this.contentChanged(this.props, nextProps) || this.props.readOnly !== nextProps.readOnly;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          config = _this$props.config,
          content = _this$props.content,
          readOnly = _this$props.readOnly;

      if (this.shouldReinitialize(prevProps, this.props)) {
        this.init(config);
      } else if (this.contentChanged(prevProps, this.props)) {
        this.editor.setContent(content);
      } else if (readOnly !== prevProps.readOnly) {
        this.editor.setMode(readOnly ? Modes.READONLY : Modes.DESIGN);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.remove();
    }
  }, {
    key: "shouldReinitialize",
    value: function shouldReinitialize(oldProps, newProps) {
      return newProps.config !== oldProps.config || newProps.content !== oldProps.content && newProps.uniqueKey === null || newProps.uniqueKey !== null && newProps.uniqueKey !== oldProps.uniqueKey || !this.editor;
    }
  }, {
    key: "contentChanged",
    value: function contentChanged(oldProps, newProps) {
      return newProps.content !== oldProps.content && newProps.content !== this.editor.getContent() && newProps.uniqueKey !== null;
    }
  }, {
    key: "createKey",
    value: function createKey() {
      return Date();
    }
  }, {
    key: "init",
    value: function init(config) {
      var _this = this;

      var readOnly = this.props.readOnly;

      if (this._initialized) {
        this.remove();
      }

      var selector = "#" + this.id;
      var setupCallback = config.setup;

      var setup = function setup(editor) {
        _this.editor = editor;

        if (readOnly) {
          editor.on('init', function () {
            editor.setMode(Modes.READONLY);
          });
        }

        Object.keys(_constants.EVENTS).forEach(function (mceEventName) {
          var handler = _this.props[_constants.EVENTS[mceEventName]];

          if (typeof handler !== 'function') {
            return;
          }

          editor.on(mceEventName, function (event) {
            // native DOM events don't have access to the editor so we pass it here
            handler(event, editor);
          });
        });

        if (typeof setupCallback === 'function') {
          setupCallback(editor);
        }
      };

      if (config.baseURL) {
        _tinymce.default.baseURL = config.baseURL;
      }

      _tinymce.default.init((0, _extends2.default)({}, config, {
        selector: selector,
        setup: setup
      }));

      this._initialized = true;
    }
  }, {
    key: "remove",
    value: function remove() {
      _tinymce.default.EditorManager.execCommand('mceRemoveEditor', true, this.id);

      this._initialized = false;
      this.editor = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          config = _this$props2.config,
          content = _this$props2.content,
          uniqueKey = _this$props2.uniqueKey;
      return config.inline ? _react.default.createElement("div", {
        key: uniqueKey || this.createKey(),
        id: this.id,
        className: className // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: content
        }
      }) : _react.default.createElement("textarea", {
        id: this.id,
        className: className,
        style: {
          visibility: 'hidden'
        },
        value: content,
        onChange: noop
      });
    }
  }]);
  return TinyMCE;
}(_react.Component);

var propTypes = {
  config: _react.PropTypes.object,
  content: _react.PropTypes.string,
  readOnly: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  uniqueKey: _react.PropTypes.string
}; // add handler propTypes

Object.keys(_constants.EVENTS).forEach(function (name) {
  propTypes[_constants.EVENTS[name]] = _react.default.PropTypes.func;
});
TinyMCE.propTypes = propTypes;
TinyMCE.defaultProps = {
  readOnly: false,
  uniqueKey: null
};
var _default = TinyMCE;
exports.default = _default;
module.exports = exports.default;